module.exports = __webpack_public_path__ + "img/marcoV.ba78eb84.svg";